import React from "react";
import stilePulsanti from "../interfaccia/stilePulsanti";
import apiUrl from "../Apiurl";

function TastoRitirati(props) {

    const stato = props.stato;
    const nuovoStato = props.nuovoStato;

    const {
        //buttonClassesWhite,
        buttonClassesWhiteNoBorder
    } = stilePulsanti

    let dicituraTasto;

    if (nuovoStato === "ARCHIVIATO") {
        dicituraTasto = "ARCHIVIA";
    } else {
        dicituraTasto = "RITIRATI";
    }

    const cambiaStatoInRitirato = async function () {

        try {
           
            const data = {
                statoPrecedente: stato,
                nuovoStato: nuovoStato,
                mag: "Prato Nevoso"
            }
            const dataToSend = JSON.stringify(data);
            let request = new XMLHttpRequest();
            request.open('PATCH', apiUrl + "/logistica/sparaOrdini/cambioStatoDaStato", true);
            request.setRequestHeader('Content-Type', 'application/json');
            request.send(dataToSend);
        } catch (err) {
            console.log("Errore nell'invio del prodotto alle API': " + err)
            throw err;
        }
    }


    return (
        <button className={buttonClassesWhiteNoBorder}
            onClick={cambiaStatoInRitirato}
        >{dicituraTasto}</button>
    )

}

export default TastoRitirati;